import React from "react";
import { motion } from "framer-motion";
import img from "../../assets/About/about-01.jpeg";
// 👉 Add your founder's photo file here (e.g. assets/About/founder.jpeg)
//    and update the path below if you save it somewhere else.
import founderImg from "../../assets/images/Founder-image/founder.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";

const AboutPageSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Color Palette — unchanged from original
  const accentBurgundy = "#7A1F2B";
  const pureBlack = "#000000";
  const pureWhite = "#FFFFFF";

  const stats = [
    { label: "Successful Cases", end: 2500, suffix: "+" },
    { label: "Expert Attorneys", end: 8, suffix: "+" },
    { label: "Global Clients", end: 100, suffix: "+" },
    { label: "Awards Won", end: 120, suffix: "+" },
  ];

  const valueGroups = [
    {
      title: "Private Wealth & Litigation",
      desc: "Legal services for private wealth clients across all specialist areas.",
      items: [
        "Human Rights",
        "Writ / SLP",
        "Business Disputes",
        "Real Estate",
        "Family Law",
        "Criminal Law",
      ],
      align: "left",
    },
    {
      title: "Advisory & Implementation",
      desc: "Strategic recurring legal services including company secretarial work, family protocols, and estate planning.",
      items: [
        "Asset Acquisition",
        "Wealth Restructuring",
        "Probate Services",
        "Conveyance Work",
      ],
      align: "right",
    },
  ];

  const philosophy = [
    {
      title: "Integrity",
      desc: "Honesty is the bedrock of our practice. We maintain absolute transparency in every case.",
    },
    {
      title: "Precision",
      desc: "In law, details are everything. Our strategic approach leaves no stone unturned.",
    },
    {
      title: "Tradition",
      desc: "We honor the classical roots of legal practice while embracing modern innovation.",
    },
    {
      title: "Excellence",
      desc: "We strive for nothing less than the most favorable outcome for our patrons.",
    },
  ];

  return (
    <div className="bg-white font-serif overflow-hidden">
      {/* --- 1. HERO --- */}
      <section className="relative px-6 md:px-12 py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-[1.1fr_0.9fr] gap-0 lg:gap-16 items-stretch">
          {/* Text column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="flex flex-col justify-center py-10"
          >
            <div className="flex items-center gap-4 mb-6">
              <div
                className="w-12 h-[2px]"
                style={{ backgroundColor: accentBurgundy }}
              ></div>
              <p
                className="uppercase tracking-[0.4em] text-[10px] font-bold font-sans"
                style={{ color: accentBurgundy }}
              >
                Established 1995
              </p>
            </div>

            <h1
              className="text-5xl md:text-7xl font-bold leading-[1.05] mb-8"
              style={{ color: pureBlack }}
            >
              Legacy of <br />
              <span className="italic font-light opacity-70">Justice.</span>
            </h1>

            <div className="text-gray-700 text-base leading-relaxed max-w-xl font-sans mb-10 space-y-5 text-justify">
              <p>
                <span className="font-bold" style={{ color: pureBlack }}>
                  Rai & Associates
                </span>{" "}
                law firm focuses on building professional relationships with
                its clients based on{" "}
                <span className="font-semibold text-black">
                  trust, confidentiality, and sound business and technical
                  methodology
                </span>{" "}
                across all legal services. We are widely reputed for
                consistent quality and expertise, and have been ranked as a
                leader in our field.
              </p>
              <p>
                We provide legal services to private wealth clients across
                all specialist areas, including{" "}
                <span className="font-semibold text-black">
                  human rights matters, writ/SLP, business disputes,
                  contract, real estate, family, and civil law, as well as
                  criminal issues
                </span>
                , at all wealth tiers.
              </p>
            </div>
        <Link
  to="/contact-us"
  className="self-start px-10 py-4 border transition-all duration-500 uppercase tracking-widest text-xs font-bold font-sans mb-12 inline-block"
  style={{
    borderColor: pureBlack,
    color: pureBlack,
    backgroundColor: pureWhite,
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = pureBlack;
    e.currentTarget.style.color = pureWhite;
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = pureWhite;
    e.currentTarget.style.color = pureBlack;
  }}
>
  Contact-us
</Link>

            {/* Inline stat ticker — replaces the old floating badge */}
            <div className="flex items-center gap-8 border-t border-gray-200 pt-8 font-sans">
              {/* <div>
                <p className="text-3xl font-bold" style={{ color: pureBlack }}>
                  30+
                </p>
                <p
                  className="text-[10px] uppercase tracking-widest font-bold"
                  style={{ color: accentBurgundy }}
                >
                  Years
                </p>
              </div> */}
              <div className="w-px h-10 bg-gray-200"></div>
              <div>
                <p className="text-3xl font-bold" style={{ color: pureBlack }}>
                  8+
                </p>
                <p
                  className="text-[10px] uppercase tracking-widest font-bold"
                  style={{ color: accentBurgundy }}
                >
                  Attorneys
                </p>
              </div>
              <div className="w-px h-10 bg-gray-200"></div>
              <div>
                <p className="text-3xl font-bold" style={{ color: pureBlack }}>
                  2.5k+
                </p>
                <p
                  className="text-[10px] uppercase tracking-widest font-bold"
                  style={{ color: accentBurgundy }}
                >
                  Cases Won
                </p>
              </div>
            </div>
          </motion.div>

          {/* Image column — original photo, reused as a full-bleed panel */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="relative min-h-[420px] lg:min-h-full"
          >
            <img
              src={img}
              alt="Rai & Associates — firm interior"
              className="absolute inset-0 w-full h-full object-cover grayscale"
            />
            <div
              className="absolute inset-0"
              style={{ backgroundColor: `${pureBlack}1A` }}
            ></div>
          </motion.div>
        </div>
      </section>

      {/* --- 2. FOUNDER'S MESSAGE (new section) --- */}
      <section
        className="py-24 sm:py-32"
        style={{ backgroundColor: pureBlack }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-16 items-center">
          {/* Founder portrait — offset burgundy frame, the firm's signature motif */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4 relative"
          >
            <div
              className="absolute inset-0 border-2 translate-x-5 translate-y-5"
              style={{ borderColor: accentBurgundy }}
            ></div>
            <div className="relative aspect-[4/5] overflow-hidden shadow-2xl">
              <img
                src={founderImg}
                alt="Founder, Rai & Associates"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          {/* Quote */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-8"
          >
            <span
              className="text-xs font-bold tracking-[0.3em] uppercase block mb-6 font-sans"
              style={{ color: accentBurgundy }}
            >
              A Message From Our Founder
            </span>
            <p className="text-2xl md:text-3xl text-white italic font-light leading-relaxed mb-8">
              "Every client who walks through our doors carries a question
              that matters to them above all others. Our work is to answer
              it with patience, precision, and an unwavering commitment to
              what is right."
            </p>
            <div
              className="w-16 h-[2px] mb-5"
              style={{ backgroundColor: accentBurgundy }}
            ></div>
            <p className="text-white font-bold font-sans text-lg">
              Kuldeep Rai
            </p>
            <p className="text-gray-400 font-sans text-sm uppercase tracking-widest">
              Founder 
            </p>
          </motion.div>
        </div>
      </section>

      {/* --- 3. CORE VALUES (alternating rows, was a 2-card grid) --- */}
      <section className="py-24 sm:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-16"
          >
            <span
              className="text-xs font-bold tracking-[0.3em] uppercase block mb-4 font-sans"
              style={{ color: accentBurgundy }}
            >
              Core Values
            </span>
            <h2
              className="text-4xl md:text-5xl font-bold leading-tight"
              style={{ color: pureBlack }}
            >
              Foundations of{" "}
              <span className="font-light opacity-80">Client Trust</span>
            </h2>
          </motion.div>

          <div className="divide-y divide-gray-200 border-t border-b border-gray-200">
            {valueGroups.map((group, idx) => (
              <motion.div
                key={group.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
                className="grid md:grid-cols-12 gap-8 py-12"
              >
                <div
                  className={`md:col-span-5 ${
                    group.align === "right" ? "md:order-2" : "md:order-1"
                  }`}
                >
                  <h3
                    className="text-2xl md:text-3xl font-bold mb-4 font-sans"
                    style={{ color: pureBlack }}
                  >
                    {group.title}
                  </h3>
                  <p className="text-gray-700 font-sans leading-relaxed">
                    {group.desc}
                  </p>
                </div>
                <div
                  className={`md:col-span-7 flex flex-wrap gap-x-8 gap-y-4 content-start ${
                    group.align === "right" ? "md:order-1" : "md:order-2"
                  }`}
                >
                  {group.items.map((item) => (
                    <span
                      key={item}
                      className="flex items-center gap-3 text-xs uppercase tracking-widest font-bold text-gray-700 font-sans"
                    >
                      <span
                        className="w-2 h-2 rounded-full shrink-0"
                        style={{ backgroundColor: accentBurgundy }}
                      ></span>
                      {item}
                    </span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* --- 4. PHILOSOPHY (dark, staggered list instead of 2x2 grid) --- */}
      <section
        className="py-24 sm:py-32"
        style={{ backgroundColor: pureBlack }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Our{" "}
              <span style={{ color: accentBurgundy }} className="font-light">
                Philosophy
              </span>
            </h2>
            <div
              className="w-20 h-[3px]"
              style={{ backgroundColor: accentBurgundy }}
            ></div>
          </div>

          <div className="divide-y divide-gray-800">
            {philosophy.map((item, idx) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                className="flex flex-col md:flex-row md:items-baseline gap-4 md:gap-12 py-8 group"
              >
                <h4
                  style={{ color: accentBurgundy }}
                  className="text-xl md:w-1/4 font-bold uppercase tracking-widest font-sans transition-all group-hover:translate-x-2"
                >
                  {item.title}
                </h4>
                <p className="text-gray-300 font-sans leading-relaxed text-base md:w-3/4">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* --- 5. STATS --- */}
      <section ref={ref} className="py-20 border-t border-gray-100 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 divide-x divide-gray-200">
          {stats.map((stat, i) => (
            <div key={i} className="text-center px-4">
              <p
                className="text-5xl lg:text-6xl font-bold mb-3"
                style={{ color: pureBlack }}
              >
                {inView && (
                  <CountUp
                    start={0}
                    end={stat.end}
                    duration={2.5}
                    separator=","
                    suffix={stat.suffix}
                  />
                )}
              </p>
              <p
                className="text-[11px] uppercase tracking-[0.3em] font-bold font-sans"
                style={{ color: accentBurgundy }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutPageSection;